
























































































































































import { Vue, Prop, Component, Watch } from 'vue-property-decorator';
import { InputValidation } from '../../../helpers/inputValidation';
import { IThirdPartyTracker, ThirdPartyTracker, IThirdPartyTrackerTypeOption, ThirdPartyTrackerType, ThirdPartyTrackerTypeOptionBuilder, ThirdPartyTrackerTypeBuilder } from '@models';
import { PropType } from 'vue';
import { cloneDeep, tap } from 'lodash';
import { Environment } from '../../../helpers/Environment';
import { MacroSwapHelper } from '../../../helpers/MacroSwapHelper';


@Component
export default class ThirdPartyTrackersEditor extends Vue {
  name = 'thirdpartytrackers-editor';
  inputValidation = InputValidation;
  environment: Environment = new Environment();

  @Prop({
    type: Array as PropType<IThirdPartyTracker[]>,
    default: () => []
  })
  value: IThirdPartyTracker[];

  @Prop({ type: Boolean, default: false }) clearCurrentSelection: boolean;

  types: IThirdPartyTrackerTypeOption[] = [
    new ThirdPartyTrackerTypeOptionBuilder(ThirdPartyTrackerType.IMPRESSION).build(),
    /*{ id: "moat", name: "MOAT" },*/
    new ThirdPartyTrackerTypeOptionBuilder(ThirdPartyTrackerType.IAS_VIEWABILITY).build(),
    new ThirdPartyTrackerTypeOptionBuilder(ThirdPartyTrackerType.OTHER_VIEWABILITY).build()
  ];

  currentTrackerInput: IThirdPartyTracker = new ThirdPartyTracker();
  currentTrackerRef: IThirdPartyTracker;

  get local(): IThirdPartyTracker[] {
    return this.value || [];
  }

  async addThirdPartyTrackerRow() {
    this.clearSelection();
    this.clearError();

    if (this.currentTrackerInput.tag && this.currentTrackerInput.tag.length > 0) {
      const tagType = await this.getTagType(this.currentTrackerInput);
      this.currentTrackerInput.tag = this.sanitizeTag(this.currentTrackerInput.tag);

      if (!tagType) {
        this.$refs.errorMessageRow.classList.add("show-error");
      }
      else {
        if (this.currentTrackerRef && this.local.indexOf(this.currentTrackerRef) != -1) {
          this.UpdateThirdPartyTracker(tagType);
        } else {
          this.addThirdPartyTracker(this.currentTrackerInput);
        }

        this.currentTrackerInput = new ThirdPartyTracker();
        this.currentTrackerRef = undefined;
        this.$refs.trackerInput.focus();
      }
    }
  }

  editThirdPartyTracker(e, value: IThirdPartyTracker) {
    this.clearError();
    if (e.currentTarget.classList.contains("tracker-selected")) {
      e.currentTarget.classList.remove("tracker-selected");

      this.currentTrackerInput = new ThirdPartyTracker();
      this.currentTrackerRef = undefined;
    } else {
      this.clearSelection();
      e.currentTarget.classList.add("tracker-selected");

      this.currentTrackerInput = cloneDeep(value);
      this.currentTrackerRef = value;
    }
  }

  sanitizeTag(input: string) : string {
    let output = input?.trim() || '';
    output = output.replace(/(´)|(`)/g, '\'');

    return output;
  }

  clearSelection() {
    //clear all selections and select the current row
    const rows = document.getElementsByClassName("added-tracker-row");
    for (let i = 0; i < rows.length; i++) {
      rows[i].classList.remove("tracker-selected");
    }
  }

  UpdateThirdPartyTracker(tagType: IThirdPartyTrackerTypeOption) {
    this.local[this.local.indexOf(this.currentTrackerRef)].tag = this.currentTrackerInput.tag;
    this.local[this.local.indexOf(this.currentTrackerRef)].type = tagType.id;

    this.$emit('input', this.local)
  }

  addThirdPartyTracker(value: IThirdPartyTracker) {
    this.$emit('input', tap(this.value, v => v.push(cloneDeep(value))))
  }

  removeThirdPartyTracker(e, item: IThirdPartyTracker) {
    e.stopPropagation();
    this.clearError();
    this.clearSelection();
    this.currentTrackerInput = new ThirdPartyTracker();
    this.currentTrackerRef = undefined;
    this.$emit('input', this.local.filter(x => x != item));
  }

  changeType(e, item: IThirdPartyTracker, isNext: boolean) {
    e.stopPropagation();
    this.clearError();
    const currentTypeIndex = this.types.indexOf(this.types.find(x => x.id === item.type));

    let newIndex = currentTypeIndex;
    if (isNext) {
      newIndex = (newIndex + 1) % this.types.length;
    } else {
      newIndex = newIndex <= 0 ? newIndex = this.types.length - 1 : newIndex - 1;
    }

    item.type = this.types[newIndex].id;
  }

  async getTagType(item: IThirdPartyTracker): Promise<IThirdPartyTrackerTypeOption | null> {
    const tag = this.sanitizeTag(item.tag);
    const tagType = await new ThirdPartyTrackerTypeBuilder().fromTagAsync(tag);

    if (tagType === null) {
      return null;
    }

    const result = new ThirdPartyTrackerTypeOptionBuilder(tagType).build();
    return result;
  }

  getTagTypeName(item: IThirdPartyTracker): string {
    let result = 'Unknown';

    if (this.types.find(x => x.id === item.type)) {
      result = this.types.find(x => x.id === item.type).name;
    }

    return result; 
  }

  async onTagChanged(item: IThirdPartyTracker) {
    this.clearError();

    this.currentTrackerInput.type = (await this.getTagType(item))?.id;
  }

  clearError() {
    this.$refs.errorMessageRow.classList.remove("show-error");
  }

  replaceableTags(item: IThirdPartyTracker): { key: string, value: string }[] {
    return MacroSwapHelper.FindReplaceableTags(item.tag);
  }

  replaceTag(key: string, item: IThirdPartyTracker) {
    item.tag = MacroSwapHelper.ReplaceTag(key, item.tag);
  }

  @Watch('clearCurrentSelection')
  clearCurrentSelectionChanged() {
    this.clearError();
    this.clearSelection();
    this.currentTrackerInput = new ThirdPartyTracker();
    this.currentTrackerRef = undefined;
  }
}
